<template>
  <div id="modalAccount" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Minha Conta</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="updatePassword">
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <p><strong>Nome:</strong> {{ user.name }}</p>
              </div>
              <div v-if="user.nickname" class="col-sm-6">
                <p>
                  <strong>Nome de Usuário:</strong>
                  {{ user.nickname }}
                </p>
              </div>
              <div class="col-sm-12">
                <p><strong>E-mail:</strong> {{ user.email }}</p>
              </div>
              <div class="col-sm-12">
                <p>
                  <strong>Telefone:</strong> {{ user.phone ? user.phone : '-' }}
                </p>
              </div>
            </div>
            <hr class="mt-2" />
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Senha Antiga: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.oldPassword.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.oldPassword.$model"
                />
                <span
                  v-if="v$.oldPassword.minLength.$invalid"
                  class="invalid-feedback"
                >
                  A senha deve ter pelo menos
                  {{ v$.oldPassword.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Nova Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.password.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.password.$model"
                />
                <span
                  v-if="v$.password.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
                <span
                  v-if="v$.password.minLength.$invalid"
                  class="invalid-feedback"
                >
                  A senha deve ter pelo menos
                  {{ v$.password.minLength.$params.min }} caracteres
                </span>
              </div>
              <div class="col-sm-6">
                <label class="form-label">
                  Confirme a Nova Senha: <span class="text-danger">*</span>
                </label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': v$.confirmPassword.$errors.length }"
                  placeholder="•••••••••••"
                  v-model="v$.confirmPassword.$model"
                />
                <span
                  v-if="v$.confirmPassword.sameAsPassword.$invalid"
                  class="invalid-feedback"
                >
                  As senhas devem ser idênticas
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Atualizar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Atualizar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'AccountModal',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      userId: this.$store.getters.user.id,
      user: {
        name: '',
        nickname: '',
        email: '',
        phone: '',
      },
      oldPassword: '',
      password: '',
      confirmPassword: '',
      disableButton: false,
    }
  },

  methods: {
    async getUser() {
      try {
        this.user = await this.$store.dispatch('getUser', this.userId)
        showModal('modalAccount')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async updatePassword() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch('updatePassword', {
            userId: this.userId,
            oldPassword: this.oldPassword,
            password: this.password,
            confirmPassword: this.confirmPassword,
          })

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      oldPassword: {
        required,
        minLength: minLength(6),
      },
      password: {
        required,
        minLength: minLength(6),
      },
      confirmPassword: {
        sameAsPassword: sameAs(this.password),
      },
    }
  },

  mounted() {
    this.getUser()
  },
}
</script>
